import type { IconData } from '@stacksjs/iconify-core'

export const description: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M334.627 16H48v480h424V153.373ZM440 166.627V168H320V48h1.373ZM80 464V48h208v152h152v264Z\"/><path fill=\"currentColor\" d=\"M136 296h224v32H136zm0 80h224v32H136z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default description
